import React, { Suspense, useCallback, useEffect, useState } from 'react';
import { UseQueryResult } from 'react-query';

import GlobalPersonDrawer from 'app/components/Drawers/GlobalPerson/GlobalPersonDrawer';
import { Reaction, ReactionsResponse } from 'services/reactions';
import { singularOrPlural } from 'utils';

import { HomeBaseDrawerWrapper } from '../../HomeDrawers/HomeBaseDrawer/styled';
import ShareBarLikeDrawerPerson from './ShareBarLikeDrawerPerson';
import {
  ShareBarLikeDrawerListContainer,
  ShareBarLikeDrawerTitle,
  ShareBarLikeDrawerWrapper,
} from './styled';

interface ShareBarLikeDrawerProps {
  query: UseQueryResult<ReactionsResponse, Error>;
}

export default function ShareBarLikeDrawer({ query }: ShareBarLikeDrawerProps) {
  const { data, isRefetching } = query;
  const [globalDrawer, setGlobalDrawer] = useState<{ slug: string; show: boolean }>({
    slug: null,
    show: false,
  });

  useEffect(() => {
    query.refetch();
  }, []);

  const sortByDatetime = useCallback(
    (a: Reaction, b: Reaction) => {
      return new Date(b.datetime).getTime() - new Date(a.datetime).getTime();
    },
    [data]
  );

  if (isRefetching) return <ShareBarLikeDrawerWrapper />;

  return (
    <>
      <ShareBarLikeDrawerWrapper>
        <ShareBarLikeDrawerTitle>
          Liked by {data.reactions.length}{' '}
          {singularOrPlural(data.reactions.length, 'person', 'people')}
        </ShareBarLikeDrawerTitle>
        <ShareBarLikeDrawerListContainer>
          {data.reactions.sort(sortByDatetime).map((reaction, index) => (
            <ShareBarLikeDrawerPerson
              key={index}
              reaction={reaction}
              setGlobalDrawer={setGlobalDrawer}
            />
          ))}
        </ShareBarLikeDrawerListContainer>
      </ShareBarLikeDrawerWrapper>
      {globalDrawer.show ? (
        <Suspense fallback={<HomeBaseDrawerWrapper />}>
          <GlobalPersonDrawer
            slug={globalDrawer.slug}
            comingFromList
            backToListAction={() => setGlobalDrawer({ slug: null, show: false })}
          />
        </Suspense>
      ) : null}
    </>
  );
}
